import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  /** When true, emit <meta name="robots" content="noindex,follow"> to keep the page out of search. */
  noindex?: boolean;
}

const SUFFIX = " | JobCam Australia";

export function useMeta({ title, description, noindex = false }: MetaOptions) {
  useEffect(() => {
    document.title = title.endsWith(SUFFIX) ? title : title + SUFFIX;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    // Index state is set explicitly every render so SPA navigation can't leave a
    // stale noindex on a page that should be indexed (or vice versa).
    setMeta("robots", noindex ? "noindex,follow" : "index,follow");

    const setOg = (property: string, content: string) => {
      let el = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setOg("og:title", title + SUFFIX);
    setOg("og:description", description);
    setMeta("twitter:title", title + SUFFIX);
    setMeta("twitter:description", description);
  }, [title, description]);
}
